module.exports = __webpack_public_path__ + "assets/d62574a92c834fb041db8c58cc5b86a8.png";